import React from "react";
import "./Experience.css";
import { BsPatchCheckFill,BsFillBootstrapFill } from "react-icons/bs";
import {SiFirebase,SiSocketdotio,SiPostman,SiHeroku,SiMysql,SiExpress,SiMongodb,SiTailwindcss,SiRedux,SiJquery,SiReact,SiChakraui,SiJavascript,SiAdobephotoshop,SiAdobeillustrator,SiAdobeaftereffects,SiAdobeaudition,SiAutodesk,SiAdobepremierepro,SiVisualstudio} from 'react-icons/si'
import {RiCss3Line} from 'react-icons/ri'
import {AiOutlineHtml5,AiFillGithub} from 'react-icons/ai'
import {TfiNotepad} from 'react-icons/tfi'
import {BiGitBranch} from 'react-icons/bi'
import {FaAws,FaNodeJs} from 'react-icons/fa'
import {TbBrandNextjs} from 'react-icons/tb'
import Material  from './Icon/material-ui.svg'
const Experience = () => {
  return (
    <section id="experience">
      <h5>The Skills I Have</h5>
      <h2>My Skills</h2>

      <div className="container experience__container">
        <div className="experience__frontend">
          <h3>Frontend Development</h3>
          <div className="experience__content">
            <article className="experience__details">
              <AiOutlineHtml5 className="experience__details-icon" />
              <div>
                <h4>HTML</h4>
                <small className="text-light">Experienced</small>
              </div>
            </article>
            <article className="experience__details">
              <RiCss3Line className="experience__details-icon" />
              <div>
                <h4>CSS</h4>
                <small className="text-light">Experienced</small>
              </div>
            </article>
            <article className="experience__details">
              <SiJavascript className="experience__details-icon" />
              <div>
                <h4>JavaScript</h4>
                <small className="text-light">Experienced</small>
              </div>
            </article>
            <article className="experience__details">
              <SiReact className="experience__details-icon" />
              <div>
                <h4>React Js</h4>
                <small className="text-light">Experienced</small>
              </div>
            </article>
            <article className="experience__details">
              <SiChakraui className="experience__details-icon" />
              <div>
                <h4>Chakra UI</h4>
                <small className="text-light">Experienced</small>
              </div>
            </article>
            <article className="experience__details">
              <SiJquery className="experience__details-icon" />
              <div>
                <h4>jQuery</h4>
                <small className="text-light">Intermediate</small>
              </div>
            </article>
            <article className="experience__details">
              {/* <SiJquery className="experience__details-icon" /> */}
              <img src={Material} alt="icon" id="matril" className="experience__details-icon" />
              <div>
                <h4>Material-UI</h4>
                <small className="text-light">Experienced</small>
              </div>
            </article>

            <article className="experience__details">
              <BsFillBootstrapFill className="experience__details-icon" />
              <div>
                <h4>Bootsrap</h4>
                <small className="text-light">Experienced</small>
              </div>
            </article>
            <article className="experience__details">
              <SiRedux className="experience__details-icon" />
              <div>
                <h4>Redux</h4>
                <small className="text-light">Experienced</small>
              </div>
            </article>

            <article className="experience__details">
              <SiTailwindcss className="experience__details-icon" />
              <div>
                <h4>Tailwind</h4>
                <small className="text-light">Experienced</small>
              </div>
            </article>
          </div>
          
        </div>

        

        {/* END OF FRONTEND */}

        <div className="experience__backend">
          <h3>Backend Development</h3>
          <div className="experience__content">
            <article className="experience__details">
              <FaNodeJs className="experience__details-icon" />
              <div>
                <h4>Node Js</h4>
                <small className="text-light">Experienced</small>
              </div>
            </article>
            <article className="experience__details">
              <SiMongodb className="experience__details-icon" />
              <div>
                <h4>Mongodb</h4>
                <small className="text-light">Experienced</small>
              </div>
            </article>
            <article className="experience__details">
              <SiMysql className="experience__details-icon" />
              <div>
                <h4>MySQl</h4>
                <small className="text-light">Intermediate</small>
              </div>
            </article>
            <article className="experience__details">
              <SiExpress className="experience__details-icon" />
              <div>
                <h4>Express.js</h4>
                <small className="text-light">Experienced</small>
              </div>
            </article>
            <article className="experience__details">
              <SiHeroku className="experience__details-icon" />
              <div>
                <h4>Heroku</h4>
                <small className="text-light">Experienced</small>
              </div>
            </article>
            <article className="experience__details">
              <SiPostman className="experience__details-icon" />
              <div>
                <h4>Postman</h4>
                <small className="text-light">Experienced</small>
              </div>
            </article>

            <article className="experience__details">
              <TbBrandNextjs className="experience__details-icon" />
              <div>
                <h4>Next.js</h4>
                <small className="text-light">Intermediate</small>
              </div>
            </article>

            <article className="experience__details">
              <SiSocketdotio className="experience__details-icon" />
              <div>
                <h4>WebSocket</h4>
                <small className="text-light">Intermediate</small>
              </div>
            </article>
            <article className="experience__details">
              <FaAws className="experience__details-icon" />
              <div>
                <h4>AWS</h4>
                <small className="text-light">Intermediate</small>
              </div>
            </article>
            <article className="experience__details">
              <SiFirebase className="experience__details-icon" />
              <div>
                <h4>Firebase-Auth</h4>
                <small className="text-light">Intermediate</small>
              </div>
            </article>
          </div>
          
          
        </div>

      {/* Designer */}

      <div className="experience__backend">
          <h3>Graphic Designer</h3>
          <div className="experience__content">
            <article className="experience__details">
              <SiAdobephotoshop className="experience__details-icon" />
              <div>
                <h4>Adobe Photoshop</h4>
                <small className="text-light">Experienced</small>
              </div>
            </article>
            <article className="experience__details">
              <SiAdobeillustrator className="experience__details-icon" />
              <div>
                <h4>Adobe illustrator</h4>
                <small className="text-light">Experienced</small>
              </div>
            </article>
            <article className="experience__details">
              <SiAdobeaftereffects className="experience__details-icon" />
              <div>
                <h4>Adobe Aftereffect</h4>
                <small className="text-light">Experienced</small>
              </div>
            </article>
            <article className="experience__details">
              <SiAdobepremierepro className="experience__details-icon" />
              <div>
                <h4>Adobe Premierepro</h4>
                <small className="text-light">Intermediate</small>
              </div>
            </article>
            <article className="experience__details">
              <SiAdobeaudition className="experience__details-icon" />
              <div>
                <h4>Adobe Audition</h4>
                <small className="text-light">Intermediate</small>
              </div>
            </article>
            <article className="experience__details">
              <SiAutodesk className="experience__details-icon" />
              <div>
                <h4>3D Max</h4>
                <small className="text-light">Intermediate</small>
              </div>
            </article>
          </div>
        </div>


      {/* Tools */}

      <div className="experience__backend">
          <h3>Tools Use</h3>
          <div className="experience__content">
            <article className="experience__details">
              <SiVisualstudio className="experience__details-icon" />
              <div>
                <h4>Visual Studio Code</h4>
                <small className="text-light">Experienced</small>
              </div>
            </article>
            <article className="experience__details">
              <TfiNotepad className="experience__details-icon" />
              <div>
                <h4>Note Pad</h4>
                <small className="text-light">Intermediate</small>
              </div>
            </article>
            <article className="experience__details">
              <AiFillGithub className="experience__details-icon" />
              <div>
                <h4>GitHub</h4>
                <small className="text-light">Experienced</small>
              </div>
            </article>
            <article className="experience__details">
              <BiGitBranch className="experience__details-icon" />
              <div>
                <h4>Git</h4>
                <small className="text-light">Experienced</small>
              </div>
            </article>
            {/* <article className="experience__details">
              <SiAdobeaudition className="experience__details-icon" />
              <div>
                <h4>Adobe Audition</h4>
                <small className="text-light">Intermediate</small>
              </div>
            </article>
            <article className="experience__details">
              <SiAutodesk className="experience__details-icon" />
              <div>
                <h4>3D Max</h4>
                <small className="text-light">Intermediate</small>
              </div>
            </article> */}
          </div>
        </div>


      </div>
    </section>
  );
};

export default Experience;
